/**
 * services/scheduleMaster.js — Master Schedule Library data access (Supabase, via /api/schedule-master).
 *
 * Read path (getMasterConfig / getCatalog) is open to any signed-in team member — the Schedule
 * Builder uses it to render data-driven columns + option dropdowns. Writes are library-manager gated
 * server-side ('admin' or 'spec-library' module).
 */

const API = '/api/schedule-master'

async function call(method, body, qs) {
  const token = await window.__clerkGetToken()
  const res = await fetch(API + (qs ? '?' + qs : ''), {
    method,
    headers: method === 'GET'
      ? { 'Authorization': 'Bearer ' + token }
      : { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
    body: method === 'GET' ? undefined : JSON.stringify(body),
  })
  const j = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(j.error || 'schedule-master error: ' + res.status)
  return j
}

/** The whole library: { types, fields, options }. */
export function getMasterConfig() {
  return call('GET', null, 'what=config').then(d => ({ types: d.types || [], fields: d.fields || [], options: d.options || [] }))
}
/** Active catalog products for a type (or all). */
export function getCatalog(scheduleType) {
  return call('GET', null, 'what=catalog' + (scheduleType ? '&scheduleType=' + encodeURIComponent(scheduleType) : '')).then(d => d.items || [])
}

// ── Writes (library managers) ─────────────────────────────────────────────────
export function upsertType(type) { return call('POST', { action: 'upsertType', type }).then(d => d.type) }
export function upsertField(field) { return call('POST', { action: 'upsertField', field }).then(d => d.field) }
export function deleteField(id) { return call('POST', { action: 'deleteField', id }).then(d => d.ok) }
export function reorderFields(order) { return call('POST', { action: 'reorderFields', order }).then(d => d.ok) }

export function addOption(set_name, value) { return call('POST', { action: 'addOption', set_name, value }).then(d => d.option) }
export function renameOption(id, value) { return call('POST', { action: 'renameOption', id, value }).then(d => d.option) }
export function deleteOption(id) { return call('POST', { action: 'deleteOption', id }).then(d => d.ok) }
export function reorderOptions(order) { return call('POST', { action: 'reorderOptions', order }).then(d => d.ok) }

export function upsertCatalogItem(item) { return call('POST', { action: 'upsertCatalogItem', item }).then(d => d.item) }
export function deleteCatalogItem(id) { return call('POST', { action: 'deleteCatalogItem', id }).then(d => d.ok) }

/** Migrate one Airtable catalog table ('electrical'|'hardware') in batches. Returns the batch result. */
export function migrateCatalogBatch(table, offset, limit) {
  return call('POST', { action: 'migrateCatalog', table, offset, limit })
}
